import type { ReactNode } from "react";
import { Apple, Play, Smartphone } from "lucide-react";

export default function AppDownload() {
  return (
    <section className="bg-white pb-20">
      <div className="container-page">
        <div className="flex flex-col items-center gap-6 rounded-2xl bg-sand px-6 py-8 sm:flex-row sm:justify-between">
          <div className="flex items-center gap-4">
            <span className="grid h-14 w-14 shrink-0 place-items-center rounded-2xl bg-navy-900 text-gold-400">
              <Smartphone size={26} />
            </span>
            <div>
              <h3 className="font-display text-xl font-bold text-navy-900">
                Take Maayad With You
              </h3>
              <p className="text-sm text-slate-600">
                Your AI travel companion in your pocket. Explore. Discover. Experience.
              </p>
            </div>
          </div>
          <div className="flex flex-wrap items-center justify-center gap-3">
            <StoreButton icon={<Play size={20} className="fill-white" />} top="GET IT ON" bottom="Google Play" />
            <StoreButton icon={<Apple size={20} className="fill-white" />} top="Download on the" bottom="App Store" />
          </div>
        </div>
      </div>
    </section>
  );
}

function StoreButton({
  icon,
  top,
  bottom,
}: {
  icon: ReactNode;
  top: string;
  bottom: string;
}) {
  return (
    <button className="flex items-center gap-3 rounded-xl bg-navy-900 px-4 py-2.5 text-left text-white transition hover:bg-navy-800">
      {icon}
      <span className="leading-none">
        <span className="block text-[10px] text-white/70">{top}</span>
        <span className="block text-sm font-semibold">{bottom}</span>
      </span>
    </button>
  );
}
